import React from 'react';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { uniqueId } from 'lodash';
import PropTypes from 'prop-types';

export const LicenseType = ({ required, id, model, label, ...props }) => {
  return (
    <React.Fragment>
      <TextInput
        label={label}
        model={model}
        validators={{
          required: (value) => {
            return !value ? 'License type is required.' : '';
          },
        }}
        formatter={(value) => {
          return value.replace(/[!@#$%^&*)({}<> ,[\]+`~=\\|';":/?]/g, '');
        }}
        data-testid="license-type"
        maxLength={20}
        isClearable
        name={`${model}-input-${uniqueId()}`}
        autoComplete="none"
      />
    </React.Fragment>
  );
};
LicenseType.propTypes = {
  required: PropTypes.bool,
  id: PropTypes.string,
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
};

LicenseType.defaultProps = {
  required: false,
  id: 'licensetype',
  label: 'License Type',
};
